import { createTheme, Theme } from '@mui/material/styles';
import { colorsByMode, ThemeMode } from './styles/themeColors';

/**
 * Builds the Material UI theme for the given mode.
 *
 * MUI needs concrete colors (it computes hover/contrast shades internally),
 * so this reads the raw values from `themeColors.ts` rather than the
 * CSS-variable `palette`. Both stay in sync because they share that source.
 */
export function buildTheme(mode: ThemeMode): Theme {
  const colors = colorsByMode[mode];

  return createTheme({
    // Fonts are driven by CSS variables (--font-body / --font-display) so they
    // can be themed/overridden without rebuilding the MUI theme.
    typography: {
      fontFamily: "var(--font-body)",
      h1: { fontFamily: "var(--font-display)", fontWeight: 700 },
      h2: { fontFamily: "var(--font-display)", fontWeight: 700 },
      h3: { fontFamily: "var(--font-display)", fontWeight: 600 },
      h4: { fontFamily: "var(--font-display)", fontWeight: 600 },
      h5: { fontFamily: "var(--font-display)", fontWeight: 600 },
      h6: { fontFamily: "var(--font-display)", fontWeight: 600 },
    },
    palette: {
      mode,
      primary: {
        main: colors.accent,
        contrastText: colors.accentText,
      },
      secondary: {
        main: colors.teal,
        contrastText: colors.tealText,
      },
      background: {
        default: colors.bgApp,
        paper: colors.bgPrimary,
      },
      text: {
        primary: colors.textPrimary,
        secondary: colors.textSecondary,
      },
      error: {
        main: colors.betWrong,
      },
      success: {
        main: colors.betCorrect,
      },
      divider: colors.border,
    },
  });
}

export default buildTheme('dark');
